import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PopoverModule } from 'ngx-bootstrap/popover';

import { TooltipComponent } from './tooltip.component';
import {MatTooltipModule} from "@angular/material/tooltip";

@NgModule({
    imports: [CommonModule, TranslateModule, PopoverModule, MatTooltipModule],
    exports: [TooltipComponent],
    declarations: [TooltipComponent]
})
export class TooltipModule {}
